module.exports = __webpack_public_path__ + "img/socialv-no-data_matting.d388879.gif";